import { Directive, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';


@Directive({
    selector: '[appDebounce]',
})
export class DebounceDirective implements OnInit, OnDestroy {

    @Output() appDebounce = new EventEmitter<string>();
    @Input() appDebounceTime = 400;
    textChanged = new Subject<string>();
    subscription: Subscription;

    @HostListener('keyup', ['$event'])
    public onKeyup($event) {
        this.textChanged.next($event.target.value);
    }

    ngOnInit() {
        this.subscription = this.textChanged
            .pipe(debounceTime(this.appDebounceTime))
            .subscribe(value => {
                this.appDebounce.emit(value);
            });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

}
